(function() {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fastrr-boost-ui.pickrr.com/assets/styles/shopify.css';
    link.type = 'text/css';
    document.head.appendChild(link); // Append the <link> tag to the <head>
})();
